<template>
  <div class="grid-view parent-wrapper-writeoff" :style="dialogHeight?dialogHeight:''">
    <div class="main-content">
      <search-item
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="showSimple"
        :is-append-query="isAppendQuery"
        :expand-adv="true"
        sim-url=""
        adv-url=""
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        :is-simple-query.sync="isSimpleQuery"
        :custom-sim-query-placeholder="customSimQueryPlaceholder"
        :config-module="configModule"
        :grid-config-module="gridConfigModule"
        :col-settings="isDialog?{span:12}:{
          xs: 12,
          sm: 12,
          md: 12,
          lg: 8,
          xl: 6
        }"
        @query="queryBtnClickHandler"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template v-slot:operations>
          <slot name="operations" />
          <cargo-grid-state-btn v-if="cargoGridStateBtn" :grid-params="gridParams" :config-module="gridConfigModule" />
        </template>
        <template v-slot:searchAreaHeader>
          <slot name="searchAreaHeader" />
        </template>
      </search-item>
      <div class="section grid-wrapper" :style="gridHeight?gridHeight:''">
        <cargo-ag-grid-wrapper
          no="grid"
          :config-module="gridConfigModule"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-row-groups="dataListDragGroup"
          :style="gridHeight?gridHeight:''"
        />
      </div>
      <div id="footer-wrapper-tab-writeoff" class="pagination-wrapper">
        <div v-if="showChargeCurrencyTotalGroup" :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 5px">
          <span v-show="dataShow && totalAmountToCurrency.selectionCountLabel" v-text="totalAmountToCurrency.selectionCountLabel" />
          <charge-currency-total-group
            v-if="reCalc"
            key="chargeCurrencyTotalGroup"
            ar-field="ar"
            currency-field="currency"
            data-field="amount"
            :amount-to-currency="localCurrency"
            rate-field="rate"
            type="revenueAbs"
            :amount-to-currency-label="$t('Clearing.Equivalent')"
            :data-provider="totalAmountToCurrency.dataProvider"
            :arap-group="arapGroup"
            :show-wht="showWht"
          />
          <actual-charge-sum-by-currency
            v-if="reCalc && viewSource === 'tabWriteOffList'"
            key="chargeSumByCurrency"
            :data-provider="totalAmountToCurrency.dataProvider"
          />
        </div>
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            no="left-pagination"
            style="text-align: left;"
            :total="pageConditions.total"
            layout="total"
          />
        </div>
        <cargo-pagination
          v-show="!appendQuery"
          no="pagination"
          :config-module="gridConfigModule"
          :total="pageConditions.total"
          :page.sync="pageConditions.pageNum"
          :limit.sync="pageConditions.pageSize"
          @pagination="query"
        />
      </div>
      <push-log-dialog-ql
        v-if="pushLogDialog.visible"
        :visible.sync="pushLogDialog.visible"
        :uuid="pushLogDialog.uuid"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import actualChargeSumByCurrency from './actualChargeSumByCurrency'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import { formatNumberToThousands } from '@/utils'
import StrUtils from '@/utils/StrUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import {
  OPERATOR_EQUAL,
  OPERATOR_UNEQUAL,
  OPERATOR_IN,
  OPERATOR_IS_NULL,
  OPERATOR_LIKE,
  OPERATOR_NOT_LIKE
} from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import { getLoading } from '@/utils/utilBaseElement'
import * as writeoffApi from '@/api/act/writeoff'
import { cache, cacheName } from '@/utils/cacheManager'
import { getBankAccountList } from '@/api/bankAccount'
import { Once, stringToBool, DocumentManage, ApiCacheManage } from '@/utils/commonUtil'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import CommonState from '@/class/cargo/model/parameters/CommonState'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import pushLogDialogQl from '@/views/cargo/v0/Clearing/components/SharedCenter/pushLogDialogQl'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'

export default {
  name: 'WriteOffSearch',
  components: { CargoAgGridWrapper, searchItem, ChargeCurrencyTotalGroup, actualChargeSumByCurrency, pushLogDialogQl },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    customSimQueryPlaceholder: { type: String, default: '' },
    configModule: { type: String, required: true },
    gridConfigModule: { type: String, required: true },
    // 查询参数
    ar: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外
    isBankSlip: { type: Number, default: -1 }, // 是否水单
    isPrepay: { type: Number, default: -1 }, // 是否预付
    isRealSendReceive: { type: Boolean, default: false }, // 是否实收实付模块
    arapGroup: { type: Boolean, default: false }, // 是否显示应收应付
    verfDate: { type: Object, default: null }, // 销账日期  [开始日期,结束日期]
    preQuery: { type: Function, default: null }, // 查询前置处理
    showChargeCurrencyTotalGroup: { type: Boolean, default: true }, // 显示数据统计
    cargoGridStateBtn: { type: Boolean, default: false }, // 显示按钮：保存列状态、显示列状态
    showSimple: { type: Boolean, default: true },
    gridHeight: { type: String, default: '' },
    dialogHeight: { type: String, default: '' },
    isDialog: { type: Boolean, default: false }, // 对话框中引用组件时不撑开aggrid
    accountId: { type: Number, default: 0 }, // 结算单位
    rowSelectionType: { type: String, default: 'multiple' }, // 是否多选
    inputDateStart: { type: String, default: '' }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showControlledCharge: { type: Boolean, default: true }, // 显示受控费用
    showVoucherDate: { type: Boolean, default: false }, // 是否显示生成凭证日期
    showInvoiceDetail: { type: Boolean, default: false }, // 是否显示发票明细
    showBillPaymentDetail: { type: Boolean, default: false }, // 是否显示付款申请号
    showFba: { type: Boolean, default: false }, // 显示FBA相关列
    remainCondition: { type: Boolean, default: false }, // 余额条件
    showWht: { type: Boolean, default: false }, // 是否需要展示去Wht金额
    viewSource: { type: String, default: '' } // 页面请求发起方
  },
  data() {
    return {
      receiptInvoiceTitles: [],
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true, // 底部计算组件文字是否显示
      // 当前选中行
      clickRow: null,
      // 查询参数
      isSimpleQuery: false, // 是否简单查询
      exceptKeys: [], // 在查询中想要例外的对象列表
      preBankSlipStates: [], // 预收款状态
      hasPreReceiptPayment: false, // 是否维护预收付凭证
      bizDataType: 0, // 凭证类型
      enableCalcSourceRateDiff: true, // 是否计算原币汇差
      jinRongExchangeMode: false, // 锦荣交单模式
      jydToFinanceApi: false, // 集翊达用友U8CLOUD
      // 银行账户列表（列表渲染使用）
      bankAccounts: null,
      cashTransferStates: [], // 水单状态列表
      // 保存上次查询的查询条件
      conditionsAndRequires: null,
      // loading遮罩层
      loading: null,
      // grid
      rowData: [],
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {},
      once: new Once(this),
      // 分页
      pageConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      // 分页组件内统计数据
      totalAmountToCurrency: {
        dataProvider: [],
        selectionCountLabel: ''
      },
      customSearchItems: [], // 自定义高级查询项
      defaultSearchItems: [],
      searchItemAutoInit: true,
      shouldFixed: false,
      querying: false, // 查询中
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      appendQuery: false, // 追加查询
      qlToFinanceApi: false, // 青旅同步
      pushLogDialog: {
        visible: false,
        uuid: ''
      },
      documentManage: new DocumentManage()
    }
  },
  computed: {
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    showRelatedSettlementInformationForGrid() { // 列表是否展示其他结算相关信息， 例如发票号，发票备注，账单号等
      return cache && cache.config ? parseInt(cache.config.get('showRelatedSettlementInformationForGrid')) === 1 : false
    },
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    columnDefs() {
      const columnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('WriteOff.writeOffSerialNumber'),
          field: 'actualAmountNo',
          colId: 'actualAmountNo',
          enableRowGroup: true,
          width: 140,
          cellStyle: (params) => {
            if (!params.data) return null
            if (params.data.importData === true) {
              return { color: '#67C23A' }
            }
            return { color: '#409EFF' }
          }
        }, {
          headerName: this.$t('WriteOff.settleAccountsTo'),
          field: 'accountId',
          colId: 'accountId',
          enableRowGroup: true,
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              const data = params.data
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                }
              }
            }
          },
          width: 150
        }, {
          headerName: this.$t('Invoice.invoice_itemNo'),
          field: 'jobPoNo',
          colId: 'jobPoNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('WriteOff.settlementAgent'),
          field: 'settlementAgentId',
          colId: 'settlementAgentId',
          enableRowGroup: true,
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
	        }, {
	          headerName: this.$t('WriteOff.theOppositeSideCompany'),
	          field: 'paymentCompany',
	          colId: 'paymentCompany',
	          enableRowGroup: true,
	          width: 140
	        }, {
	          headerName: this.$t('WriteOff.ourSideAccount'),
	          field: 'ourBankAccount',
	          colId: 'ourBankAccount',
	          width: 140,
	          cellRenderer: (params) => {
	            return this.queryOurBankAccountLabelFunc(params.data)
	          },
	          filterValueGetter: params => {
	            return this.queryOurBankAccountLabelFunc(params.data)
	          },
	          filter: false,
	          filterParams: {}
	        }, {
	          headerName: this.$t('WriteOff.ourSideBank'),
	          field: 'ourBank',
	          colId: 'ourBank',
	          width: 100,
	          cellRenderer: (params) => {
	            return this.queryOurBankLabelFunc(params.data)
	          },
	          filterValueGetter: params => {
	            const text = this.queryOurBankLabelFunc(params.data)
	            return text || ''
	          },
	          filter: false,
	          filterParams: {}
	        }, {
          headerName: this.$t('WriteOff.billPaymentNo'),
          field: 'billPaymentNo',
          colId: 'billPaymentNo',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('WriteOff.proofNo'),
          field: 'voucherNo',
          colId: 'voucherNo',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('WriteOff.bankReceiptNo'),
          field: 'bankWaterNo',
          colId: 'bankWaterNo',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('WriteOff.writeOffPerson'),
          field: 'verificationBy',
          colId: 'verificationBy',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.writeOffDate'),
          field: 'verificationDate',
          colId: 'verificationDate',
          enableRowGroup: true,
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.revenueAndExpenditureDate'),
          field: 'payReceiveDate',
          colId: 'payReceiveDate',
          enableRowGroup: true,
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.paymentType'),
          field: 'ar',
          colId: 'ar',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('WriteOff.bankReceiptStatus'),
          field: 'cashTransferState',
          colId: 'cashTransferState',
          width: 100,
          cellRenderer: (params) => {
            return this.cashTransferStateLabelFun(params.data, 'cashTransferState')
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.revenueAndExpenditureMethod'),
          field: 'type',
          colId: 'type',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.amountReceiveTypeLabelFun(Number(params.value))
          }
        },
        {
          headerName: this.$t('Partners.isFba'),
          colId: 'fba',
          field: 'fba',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          colId: 'warehouseCode',
          field: 'warehouseCode',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.DestinationDistribution'),
          colId: 'destinationDistribution',
          field: 'destinationDistribution',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.ExpressNo'),
          colId: 'expressNo',
          field: 'expressNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.RemoteWarehouse'),
          colId: 'remoteWarehouse',
          field: 'remoteWarehouse',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: 'Shipment Id',
          colId: 'shipmentId',
          field: 'shipmentId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: 'Reference Id',
          colId: 'referenceId',
          field: 'referenceId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('WriteOff.prepaidOrNot'),
          field: 'isPrepay',
          colId: 'isPrepay',
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('WriteOff.currency'),
          field: 'currency',
          colId: 'currency',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('WriteOff.amount'),
          field: 'amount',
          colId: 'amount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(this.amountNumberColumnLabelFunc(params.data, 'amount'))
          },
          filter: false,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.theAmountOfWrittenOff'),
          field: 'verfiedAmount',
          colId: 'verfiedAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(this.amountNumberColumnLabelFunc(params.data, 'verfiedAmount'))
          },
          filter: false,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.balance'),
          field: 'remainAmount',
          colId: 'remainAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(this.remainAmountLabelFunc(params.data))
          },
          filter: false,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.actualReceiptAmount'),
          field: 'arAmount',
          colId: 'arAmount',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumberReturnZero(params.value, 2))
          },
          filter: false,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.actualPaymentAmount'),
          field: 'apAmount',
          colId: 'apAmount',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumberReturnZero(params.value, 2))
          },
          filter: false,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.financialCharges'),
          field: 'financialCost',
          colId: 'financialCost',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.exchangeGainsAndLosses'),
          field: 'diffChange',
          colId: 'diffChange',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('WriteOff.oddment'),
          field: 'clearOdd',
          colId: 'clearOdd',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          },
          summaryMode: 'sum'
        }, {
          // 原币汇差
          headerName: this.$t('WriteOff.originalCurrencyExchangeDifference'),
          field: 'sourceRateDiff',
          colId: 'sourceRateDiff',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          },
          hide: this.enableCalcSourceRateDiff
        }, {
          headerName: this.$t('WriteOff.creator'),
          field: 'createdBy',
          colId: 'createdBy',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.recheck'),
          field: 'approvedState',
          colId: 'approvedState',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.actAmountApproveLabelFun(Number(params.value))
          }
        }, {
          headerName: this.$t('WriteOff.RecheckDate'),
          field: 'dateApproved',
          colId: 'dateApproved',
          enableRowGroup: true,
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.invalid'),
          field: 'state',
          colId: 'state',
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.actAmountStateLabelFun(Number(params.value))
          }
        }, {
          headerName: this.$t('WriteOff.invoicingInformation'),
          field: 'invoiceDetail',
          colId: 'invoiceDetail',
          enableRowGroup: true,
          width: 100,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('WriteOff.remark'),
          field: 'remark',
          colId: 'remark',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('WriteOff.dayOfCreditTerm'),
          field: 'creditTerm',
          colId: 'creditTerm',
          enableRowGroup: true,
          width: 100
        }, {
          // 对方凭证号
          headerName: this.$t('WriteOff.targetVoucherNo'),
          field: 'targetVoucherNo2Charge',
          colId: 'targetVoucherNo2Charge',
          width: 100,
          enableRowGroup: true,
          hide: true
        }, {
          // 凭证日期
          headerName: this.$t('WriteOff.proofDate'),
          field: 'voucherDate2Charge',
          colId: 'voucherDate2Charge',
          enableRowGroup: true,
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.preExchangeDifference'),
          field: 'preExchangeDifference',
          colId: 'preExchangeDifference',
          width: 100,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
          }
        }, {
          field: 'approvedBy', headerName: this.$t('CargoMsg.Cargo_ApprovedBy'), enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementTypes',
          initialWidth: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypesLableFun(params.value)
          }
        },
        { headerName: this.$t('Invoice.invoice_billNo'),
          colId: 'billingNos',
          field: 'billingNos',
          initialWidth: 300,
          enableRowGroup: true,
          initialHide: !this.showRelatedSettlementInformationForGrid
        },
        {
          headerName: this.$t('Billing.billingJob_otherPartyBilling'),
          colId: 'otherPartyBilling',
          field: 'otherPartyBilling',
          initialWidth: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Billing.billingJob_agentBillNo'),
          colId: 'counterPartyBillingNos',
          field: 'counterPartyBillingNos',
          initialWidth: 180,
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_FinancialRemarks'),
          colId: 'invoiceFinancialRemarks',
          field: 'invoiceFinancialRemarks',
          initialWidth: 300,
          enableRowGroup: true,
          initialHide: !this.showRelatedSettlementInformationForGrid
        },
        { headerName: this.$t('Invoice.invoice_invoiceRemarks'),
          colId: 'invoiceRemarks',
          field: 'invoiceRemarks',
          initialWidth: 300,
          enableRowGroup: true,
          initialHide: !this.showRelatedSettlementInformationForGrid
        },
        { headerName: this.$t('Invoice.invoice_invoiceNo'),
          colId: 'invoiceNos',
          field: 'invoiceNos',
          initialWidth: 300,
          initialHide: !this.showRelatedSettlementInformationForGrid,
          wrapText: this.viewSource === 'tabWriteOffList',
          autoHeight: this.viewSource === 'tabWriteOffList',
          valueFormatter: params => {
            if (this.viewSource === 'tabWriteOffList') {
              const data = params.data
              if (data && data.arInvoiceNos && data.apInvoiceNos) {
                return `${this.$t('Clearing.AccountsReceivable')}${data.arInvoiceNos}\n${this.$t('Clearing.PayableColon')}${data.apInvoiceNos}`
              }
            }
            return params.value
          },
          filterParams: {},
          filterValueGetter: params => {
            if (this.viewSource === 'tabWriteOffList') {
              const data = params.data
              if (data && data.arInvoiceNos && data.apInvoiceNos) {
                return `${this.$t('Clearing.AccountsReceivable')}${data.arInvoiceNos} ${this.$t('Clearing.PayableColon')}${data.apInvoiceNos}`
              }
            }
            return params.data.invoiceNos
          }
        }, {
          headerName: this.$t('Payment.preRemarks'),
          field: 'preRemark',
          colId: 'preRemark',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_WriteOffHeader'),
          field: 'actualAmountTitle',
          colId: 'actualAmountTitle',
          enableRowGroup: true,
          hide: false,
          width: 120
        }, {
          headerName: this.$t('Payment.receiptPaymentNo'),
          field: 'receiptPaymentNo',
          colId: 'receiptPaymentNo',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('WriteOff.theOppositeSideBank'),
          field: 'companyBank',
          colId: 'companyBank',
          width: 100,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('WriteOff.theOppositeSideAccount'),
          field: 'companyBankAccount',
          colId: 'companyBankAccount',
          width: 100,
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'notWhtAmount',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum' },
        {
          headerName: 'SERVICE',
          field: 'whtService',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'ADVANCE',
          field: 'whtAdvance',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'VAT',
          field: 'whtVat',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('Payment.ticketNo'),
          field: 'ticketNo',
          colId: 'ticketNo',
          width: 100,
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_PushLog'), field: 'feedbackState', hide: true, width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            const uuid = params.data.uuid
            const methodOnFileViewPath = this.documentManage.getPath('onView')
            console.log('test ok')
            console.log(methodOnFileViewPath)
            return `<a onclick="${methodOnFileViewPath}('${uuid}')" style="color:blue">
                  ${this.$t('CargoMsg.Cargo_View')}
                  </a>`
          }
        }, {
          headerName: this.$t('WriteOff.writeoffSeqNoSource'),
          field: 'importData',
          colId: 'importData',
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return stringToBool(params.value) ? this.$t('WriteOff.sourceImport') : this.$t('WriteOff.sourceSystem')
          }
        }, {
          headerName: this.$t('WriteOff.invoiceTitle'),
          field: 'invoiceTitle',
          colId: 'invoiceTitle',
          width: 140
        }, {
          headerName: this.$t('WriteOff.writeoffMatchStatus'),
          field: 'writeoffMatchStatus',
          colId: 'writeoffMatchStatus',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.writeoffMatchStatusLabFun(params.value)
          }
        }, {
          headerName: this.$t('WriteOff.matchStatusReason'),
          field: 'writeoffMatchStatusReason',
          colId: 'writeoffMatchStatusReason',
          width: 200
        }
      ]
      if (this.jinRongExchangeMode) {
        columnDefs.push(
          {
            headerName: this.$t('CargoMsg.Cargo_CloudPlatformSyncStatus'),
            colId: 'jdyxkSyncStatus',
            field: 'jdyxkSyncStatus',
            enableRowGroup: true,
            initialWidth: 100,
            valueFormatter: (params) => {
              return ColumnUtils.jdyxkSyncStatusLabelFunc(Number(params.value))
            }
          },
          {
            headerName: this.$t('FinanceManage.SyncExceptionReason'),
            colId: 'jdyxkSyncFailReason',
            field: 'jdyxkSyncFailReason',
            enableRowGroup: true,
            initialWidth: 200
          }
        )
      }
      if (this.jydToFinanceApi) {
        columnDefs.push(
          {
            headerName: this.$t('Clearing.SyncCloudPlatformStatus'),
            field: 'syncExternalStatus',
            initialWidth: 100,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.hmYongYouSyncStatusLabelFunc(Number(params.value))
            }
          },
          {
            headerName: this.$t('FinanceManage.SyncExceptionReason'),
            field: 'syncExternalFailReason',
            enableRowGroup: true,
            initialWidth: 200
          }
        )
      }
      if (this.qlToFinanceApi) {
        columnDefs.push(
          {
            headerName: this.$t('Clearing.SyncCloudPlatformStatus'),
            field: 'syncExternalStatus',
            initialWidth: 100,
            valueFormatter: (params) => {
              return ColumnUtils.hmYongYouSyncStatusLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.SyncExceptionReason'),
            field: 'syncExternalFailReason',
            initialWidth: 200
          }
        )
      }

      return columnDefs
    }
  },
  watch: {
    bankAccounts() {
      this.$nextTick(() => {
        const api = this.gridParams && this.gridParams.api
        if (api && api.refreshCells) api.refreshCells({ force: true })
      })
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.qlToFinanceApi = cache.config.get('ToFinanceApi') === 'QL' // 青旅202507
        await this.initCustomSearchItems()
      }
    }
  },
  async created() {
    // 设置勾选行数据时执行一次数据统计
    const self = this
    this.gridOptions = {
      rowSelection: self.rowSelectionType,
      suppressCellSelection: true,
      defaultColDef: {
        resizable: true,
        filter: true
      },
      pagination: false,
      onSelectionChanged: this.filterChange,
      onRowDoubleClicked: this.rowDoubleClickedHandler,
      onRowClicked: this.rowClicked,
      onRowSelected: this.onRowChecked
    }
    // 配置加载
    await cache.load(cacheName.CONFIG)
    // 是否计算原币汇差
    this.enableCalcSourceRateDiff = parseInt(cache.config.get('enableCalcSourceRateDiff')) === 1
    this.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
    this.jydToFinanceApi = cache.config.get('ToFinanceApi') === 'JYDYY' // 集翊达用友U8CLOUD
    this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    // 加载银行账户列表（列表渲染使用）
    this.bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
      return res.data
    })
    await this.initCustomSearchItems()
    this.setLocalCurrency()
  },

  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
  },

  beforeDestroy() {
    this.documentManage.destory()
  },

  mounted() {
    this.scrollCallback()
    document.querySelector('.parent-wrapper-writeoff').addEventListener('scroll', this.scrollCallback)
  },
  methods: {
    // 查询 按钮事件
    queryBtnClickHandler(conditionsMap) {
      if (this.preQuery && !this.preQuery()) return
      let conditions = conditionsMap.conditions
      // 查询销账流水号
      if (conditionsMap.simpleTriggerMode && conditions) {
        this.appendQuery = false
        // 简单查询时conditions是字符串
        const value = conditions
        conditions = []
        conditions.push(new AdvancedSearchOption('FIELD_TEXT', 'actualAmount.ACTUALAMOUNTNO', value, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
      }
      const writeQuery = true
      const requires = []
      // CARGO-9716，销账日期：第一次点击查询没有生效，第二点击查询才生效
      // const verificationDateSearchOption = this.verfDate
      // if (verificationDateSearchOption != null) {
      //   conditions.push(verificationDateSearchOption.formatObj2Json())
      // }
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (!this.inputDateStart && this.inputDateEnd) {
        inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, 'actualAmount.VERIFICATIONDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.ar !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.AR', this.ar === 1).formatObj2Json())
      }
      if (this.oversea !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'charge.OVERSEA', this.oversea === 1).formatObj2Json())
      }

      if (this.isPrepay !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', this.isPrepay === 1).formatObj2Json())
      }

      if (this.isBankSlip !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.BANK_SLIP', this.isBankSlip === 1).formatObj2Json())
      }

      // 结算单位
      if (this.accountId > 0) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.ACCOUNTID', this.accountId, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }

      if (this.exceptKeys && this.exceptKeys.length > 0) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.UUID', this.exceptKeys, AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
      }

      if (this.preBankSlipStates !== null && this.preBankSlipStates.length > 0) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PRE_BANK_SLIP_STATE', this.preBankSlipStates, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PRE_AMOUNT', true).formatObj2Json())
        requires.push('checkVoucherPrePayment')
      }

      // CARGO-8364，预收付凭证
      if (FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code === this.bizDataType) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', 1).formatObj2Json())
        requires.push('checkVoucherPrePayment')
        if (AdvancedSearchOption.hasField(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)) {
          AdvancedSearchOption.removeOption(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)
        }
      } else if (FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code === this.bizDataType) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', 1).formatObj2Json())
      } else {
        if (this.hasPreReceiptPayment) {
          conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', 1, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json())
        }
      }

      if (AdvancedSearchOption.hasField(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)) {
        const special = AdvancedSearchOption.removeOption(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)
        if (!special) return
        let operator = special.operator
        if (!special.value) {
          operator = AdvancedSearchConsts.OPERATOR_NOT_IN.code
        } else {
          operator = AdvancedSearchConsts.OPERATOR_IN.code
        }
        conditions.push(new AdvancedSearchOption(null, special.fieldName, special.value, operator).formatObj2Json())
      }

      // 我方银行：值转换
      if (AdvancedSearchOption.hasField('actualAmount.OURBANK', conditions)) {
        // const option = AdvancedSearchOption.removeOption('actualAmount.OURBANK', conditions)
        // const bankAccount = this.bankAccounts.find(p => (p.bankChineseName + '' + p.currency) === String(option.value))
        // if (bankAccount) {
        //   option.value = bankAccount.bankChineseName
        // }
        // conditions.push(option)
      }

      // 认领状态：全部
      if (AdvancedSearchOption.hasField('actualAmount.BANK_SLIP_STATE', conditions)) {
        const option = AdvancedSearchOption.getOption('actualAmount.BANK_SLIP_STATE', conditions)
        const valueArray = option.value
        let seachAll = false
        valueArray.forEach(function(value) {
          if (value === -1) seachAll = true
        })
        if (seachAll) AdvancedSearchOption.removeOption('actualAmount.BANK_SLIP_STATE', conditions)
      }

      if (this.remainCondition) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.REMAINAMOUNT', 0, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json())
      }

      // if (!this.showControlledCharge) {
      //   this.getControlledConditions(conditions)
      // }

      if (this.showVoucherDate) {
        requires.push('voucherDate')
      }
      if (this.showInvoiceDetail) {
        requires.push('invoice')
      }
      if (this.showBillPaymentDetail) {
        requires.push('billPayment')
      }
      if (this.showFba) {
        requires.push('fba')
      }
      if (this.qlToFinanceApi) {
        requires.push('qlToFinanceApi')
      }
      if (writeQuery && AdvancedSearchOption.hasField('actualAmount.OURBANK', conditions)) {
        requires.push('writeQuery')
        const offsetStateOption = AdvancedSearchOption.getOption('actualAmount.OURBANK', conditions)
        // if (offsetStateOption.selectedItem != null) {
        //   offsetStateOption.value = offsetStateOption.selectedItem.currency + '||' + offsetStateOption.value
        // }
        if (offsetStateOption && offsetStateOption.value && offsetStateOption.value.length > 0) {
          const bankAccounts = this.bankAccounts.filter(p => offsetStateOption.value.includes(p.accountNo + '' + p.currency))
          const arr = []
          for (const bankAccount of bankAccounts) {
            arr.push(bankAccount.currency + '||' + bankAccount.accountNo)
          }
          AdvancedSearchOption.removeOption('actualAmount.OURBANK', conditions)
          offsetStateOption.value = arr
          conditions.push(offsetStateOption)
        }
      }
      this.preQueryActualAmount(conditions)
      // CARGO-1776，发票查询，付款申请，销账查询界面增加对方凭证号，凭证日期：默认隐藏
      requires.push('targetVoucherNo')
      // CARGO-981，汇兑损益汇率
      if (this.enableCalcSourceRateDiff) {
        requires.push('calcSourceRateDiff')
      }
      if (this.viewSource === 'tabWriteOffList') {
        requires.push('amount2RMB')
        requires.push('clearCurrencyAmount')
      }
      requires.push('billing')
      if (this.jinRongExchangeMode) {
        requires.push('jinRongExchangeMode')
      }
      if (this.jydToFinanceApi) {
        requires.push('jydToFinanceApi')
      }
      requires.push('voucherPage')
      if (this.showWhtTax) { requires.push('whtTax') }
      // 获取追加查询条件
      this.appendQuery = JobUtils.appendQueryCondition(conditions)
      // 保存查询条件
      this.conditionsAndRequires = { conditions, requires }
      this.query()
    },
    async query() {
      this.clickRowClear()
      if (!this.conditionsAndRequires) return
      const conditions = this.conditionsAndRequires.conditions
      const requires = this.conditionsAndRequires.requires
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        conditions,
        requires,
        pageSize: this.pageConditions.pageSize,
        pageNum: this.pageConditions.pageNum
      }
      params.appendQuery = this.appendQuery
      const self = this
      this.querying = true
      self.loading = getLoading()

      if (this.isRealSendReceive) {
        const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        await writeoffApi.queryActualAmountOldPageable(params).then(res => {
          self.resultHandler(res, self)
          selectedStatus.revert()
        }).catch(err => {
          self.faultHandler(err)
        })
        // ActualAmount.queryActualAmountOldPageable(conditions, requires, pageBar.pageSize, pageBar.currentPage, resultHandler, faultHandler)
      } else {
        const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        await writeoffApi.queryActualAmountPageable(params).then(res => {
          self.resultHandler(res, self)
          selectedStatus.revert()
        }).catch(err => {
          self.faultHandler(err)
        })
        // ActualAmount.queryActualAmountPageable(conditions, requires, pageBar.pageSize, pageBar.currentPage, resultHandler, faultHandler)
      }
      self.loading.close()
      this.querying = false
      // 查询完成后更新右下角统计数据
      this.refreshSelectedCount()
      // 重置
      this.$emit('clickedCallBack', null)
      this.gridOptions.api.clearFocusedCell()
    },
    // 查询前置操作
    preQueryActualAmount(conditions) {
      if (cache.config.get('ext') === '1') {
        for (const option of conditions) {
          if (option.fieldName === 'actualAmount.ACTUALAMOUNTNO' && option.value &&
            option.operator === AdvancedSearchConsts.OPERATOR_EQUAL.code &&
            option.value instanceof String &&
            String(option.value).indexOf(',') > 0) {
            option.value = String(option.value).split(',')
            break
          }
        }
      }
    },
    // 获取charge控制条件
    getControlledConditions(conditions) {
      // 是否有应付受控费用权限
      const isControlled = this.$checkPermission(['button_Charge_controlled'])
      // 是否有应收受控费用权限
      const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
      let value = 0
      if (!isControlled && !isCostControlled) {
        value = 1
      } else if (!isControlled) {
        value = 2
      } else if (!isCostControlled) {
        value = 3
      }
      if (value !== 0) {
        conditions.push(new AdvancedSearchOption(null, 'cIsControlled', value).formatObj2Json())
      }
    },
    resultHandler(res, self) {
      let results = res.data.list
      // 追加查询数据去重
      if (this.appendQuery) {
        results = JobUtils.appendQueryRepeat(self.rowData, results, this.appendQuery)
      }
      self.pageConditions.total = this.appendQuery ? results.length : Number(res.data.total)
      self.pageConditions.pageNum = Number(res.data.pageNum)
      self.rowData = results
      self.$emit('queryResultCallBack', results)
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    // 行双击事件
    rowDoubleClickedHandler(event) {
      this.clickRow = event.data
      this.$emit('doubleClickedCallBack', event.data)
    },
    // 行单击事件
    rowClicked(event) {
      this.clickRow = event.data
      console.log('querying', this.querying)
      if (!this.querying) this.$emit('clickedCallBack', event.data)
      if (!this.querying) this.$emit('selectionChangedCallBack', [event.data])
    },
    // 行首多选框勾选事件
    onRowChecked(event) {
      if (event.node.isSelected()) {
        this.rowClicked(event)
      }
    },
    // 置空clickRow
    clickRowClear() {
      this.clickRow = null
    },
    // 列表checkBox选中变更事件
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
        if (!this.querying) this.$emit('selectionChangedCallBack', selections)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
        if (!this.querying) this.$emit('selectionChangedCallBack', null)
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg === 0) {
        if (this.viewSource === 'tabWriteOffList') {
          this.totalAmountToCurrency.selectionCountLabel = this.$t('Message.Choose') + selections.length + this.$t('Message.Updated2')
        } else {
          const selectStr = this.$i18n.locale === 'zh' ? '选中' : 'selected'
          this.totalAmountToCurrency.selectionCountLabel = selectStr + ' ' + selections.length + '：'
        }
        this.totalAmountToCurrency.dataProvider = selections
      } else if (arg === 1) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectionCountLabel = ''
      } else {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.totalAmountToCurrency.selectionCountLabel = ''
      }
      // if (this.viewSource === 'tabWriteOffList' && this.totalAmountToCurrency.dataProvider) {
      //   const newDataProvider = []
      //   for (const row of this.totalAmountToCurrency.dataProvider) {
      //     if (row.amount2RMB && row.currency === 'RMB') {
      //       newDataProvider.push({ ...row, amount: row.amount2RMB })
      //     } else {
      //       newDataProvider.push(row)
      //     }
      //   }
      //   this.totalAmountToCurrency.dataProvider = newDataProvider
      // }
    },
    // 修改指定行数据并重新渲染列表
    refreshRow(data) {
      const index = this.rowData.findIndex(row => { return row.uuid === data.uuid })
      const rowData = this.rowData
      rowData[index] = data
      this.clickRow = data
      this.rowData = [...rowData]
      this.gridOptions.api.refreshCells({ force: true })
      this.$emit('queryResultCallBack', this.rowData)
      this.$emit('clickedCallBack', data)
    },
    /** *********列数据渲染函数 begin********** **/
    numberColumnLabelFunc(data, dataField) {
      if (!data) {
        return ''
      }
      if (data.ar && dataField === 'arAmount') {
        return ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'amount'), 2)
      }
      if (!data.ar && dataField === 'apAmount') {
        return ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'amount'), 2)
      }
      return '0.00'
    },
    // 剩余金额
    remainAmountLabelFunc(item) {
      // ActualAmount
      const act = item
      if (act) {
        return ColumnUtils.formatNumberReturnZero(act.amount - act.verfiedAmount, 2)
      }
      return '0.00'
    },

    amountNumberColumnLabelFunc(data, dataField) {
      if (!data) return ''
      let displayAmount = '0.00'
      if (data.hasOwnProperty('isPrepay') && data.isPrepay) {
        if (dataField === 'amount') {
          displayAmount = ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'amount'), 2)
        }
        if (dataField === 'verfiedAmount') {
          displayAmount = ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'verfiedAmount'), 2)
        }
      } else {
        // 实收实付金额
        let amount = 0.00
        if (data.hasOwnProperty('amount') && data.amount) {
          amount = Number(data.amount)
        }
        // 财务费用
        let financialCost = 0.00
        if (data.hasOwnProperty('financialCost') && data.financialCost) {
          financialCost = Number(data.financialCost)
        }

        // 汇总损益
        let diffChange = 0.00
        if (data.hasOwnProperty('diffChange') && data.diffChange) {
          diffChange = Number(data.diffChange)
        }

        // 零头短账
        let clearOdd = 0.00
        if (data.hasOwnProperty('clearOdd') && data.clearOdd) {
          clearOdd = Number(data.clearOdd)
        }
        displayAmount = ColumnUtils.formatNumberReturnZero(amount + financialCost + diffChange + clearOdd, 2)
      }
      return displayAmount
    },
    // 水单状态
    cashTransferStateLabelFun(data, dataField) {
      // CashTransferState
      const common = this.getCashTransferStateByCode(data[dataField])
      return common == null ? this.$t('Clearing.NotUsed') : (this.isZh ? common.chineseName : common.englishName)
    },
    // 根据code获取水单状态对象
    getCashTransferStateByCode(code) {
      if (this.cashTransferStates.length === 0) {
        // 水单状态
        const CASH_TRANSFER_WSY = { code: 0, englishName: 'WSY', chineseName: '未使用' }
        const CASH_TRANSFER_GSD = { code: 1, englishName: 'GSD', chineseName: '挂水单' }
        const CASH_TRANSFER_SDK = { code: 2, englishName: 'SDK', chineseName: '收到款' }
        const CASH_TRANSFER_NDHD = { code: 3, englishName: 'NDHD', chineseName: '拿到回单' }
        this.cashTransferStates = [CASH_TRANSFER_WSY, CASH_TRANSFER_GSD, CASH_TRANSFER_SDK, CASH_TRANSFER_NDHD]
      }
      for (let i = 0; i < this.cashTransferStates.length; i++) {
        if (this.cashTransferStates[i].code === code) {
          return this.cashTransferStates[i]
        }
      }
      return null
    },

	    queryOurBankLabelFunc(data) {
	      if (!data) return ''
	      const rawText = data.ourBank || ''
	      if (!Array.isArray(this.bankAccounts) || this.bankAccounts.length === 0) return rawText

	      const accountNo = data.ourBankAccount
	      const currencyCandidates = [data.ourBankCurrency, data.currency].filter(v => v !== '' && v !== null && v !== undefined)
	      if (!accountNo || currencyCandidates.length === 0) return rawText

	      let matched = null
	      for (const cur of currencyCandidates) {
	        matched = this.bankAccounts.find(b => b && b.accountNo === accountNo && b.currency === cur)
	        if (matched) break
	      }
	      if (!matched) return rawText

	      const codePart = matched.code ? ('[' + matched.code + ']') : ''
	      const currencyPart = matched.currency ? ('[' + matched.currency + ']') : ''
	      const namePart = matched.bankChineseName || rawText
	      return codePart + currencyPart + (namePart || '')
	    },
	    queryOurBankAccountLabelFunc(data) {
	      if (!data) return ''
	      if (!StrUtils.isEmpty(data.ourBankAccount)) return data.ourBankAccount
	      if (!Array.isArray(this.bankAccounts) || this.bankAccounts.length === 0) return ''

	      const rawText = data.ourBank || ''
	      if (StrUtils.isEmpty(rawText)) return ''

	      const currencyCandidates = [data.ourBankCurrency, data.currency].filter(v => v !== '' && v !== null && v !== undefined)
	      if (currencyCandidates.length === 0) return ''

	      let matched = null
	      for (const cur of currencyCandidates) {
	        matched = this.bankAccounts.find(b => b && b.bankChineseName === rawText && b.currency === cur && !StrUtils.isEmpty(b.accountNo))
	        if (matched) break
	      }
	      return matched ? (matched.accountNo || '') : ''
	    },
    /** *********列数据渲染函数 end********** **/
    scrollCallback() {
      console.log('parent-wrapper-writeoff')
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper-writeoff')
        const footer = document.getElementById('footer-wrapper-tab-writeoff')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (this.dialogHeight || (offset > containerHeight)) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    async initCustomSearchItems() {
      console.log('accountId', this.accountId)
      const defaultSearchFields = []
      // 是否重置结算单位
      let isResetAccountId = true
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'WriteOff.settlementCompany'
          searchField.itemName = 'actualAmount.ACCOUNTID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
          isResetAccountId = false
        }
      }
      if (isResetAccountId) {
        defaultSearchFields.push({
          'action': 2,
          'itemType': 'company',
          'subType': {
            'type': '',
            'tagValue': 'cmpIdx'
          },
          'fieldType': 'FIELD_COMPANY',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'actualAmount.ACCOUNTID',
          'itemLabel': 'WriteOff.settlementCompany',
          'itemValue': '',
          'defaultSelected': 0,
          'selected': 0,
          'valueExpression': '',
          'headers': [],
          'fields': [],
          'tagValue': '',
          'tagName': '',
          'lock': false,
          'defaultValue': ''
        })
      }
      // 我方银行
      if (this.bankAccounts) {
        const dataProvider = []
        for (const bankAccount of this.bankAccounts) {
          const chineseName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
          const englishName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankEnglishName
          // CARGO-15701，销账查询页签，我方银行的查询条件:币种+账号
          dataProvider.push({ code: (bankAccount.accountNo + '' + bankAccount.currency), chineseName: chineseName, englishName: englishName })
        }
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.multiple = 1
        searchField.itemLabel = 'WriteOff.ourSideBank'
        searchField.itemName = 'actualAmount.OURBANK'
        searchField.itemValue = []
        searchField.defaultValue = []
        searchField.itemCondition = AdvancedSearchConsts.FIELD_OPERATOR_MAP['multiDropDownList2']
        searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_IN.code
        searchField.fields = ['chineseName']
        searchField.tagName = 'chineseName'
        searchField.tagValue = 'code'
        searchField.lock = false
        searchField.dataProvider = dataProvider
        searchField.action = 2
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.filterType = 'global'
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 销账查询
      if (this.configModule === '509') {
        // 销账人
        let searchField = new AdvancedSearchField()
        searchField.itemType = 'user'
        searchField.subType = { 'category': 'role', 'shape': 'acct' }
        searchField.itemLabel = 'WriteOff.writeOffPerson'
        searchField.itemName = 'actualAmount.VERIFICATIONBY'
        searchField.fieldType = 'FIELD_USER'
        searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN]
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        // 对方对账单号
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemLabel = 'Billing.billingJob_otherPartyBilling'
        searchField.itemName = 'billingGroup.OTHER_PARTY_BILLING'
        searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_NOT_LIKE]
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        // 对方账单号
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemLabel = 'Billing.billingJob_agentBillNo'
        searchField.itemName = 'billing.COUNTER_PARTY_BILLING_NO'
        searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_NOT_LIKE]
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        //
        if (this.jydToFinanceApi) {
          searchField = new AdvancedSearchField()
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = [OPERATOR_IN]
          searchField.defaultConditionVal = OPERATOR_IN.code
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'actualAmountPushRecord.SEND_STATUS'
          searchField.itemLabel = 'CargoMsg.Cargo_CloudPlatformSyncStatus'
          searchField.defaultValue = []
          searchField.dataProvider = ChargeConstants.HM_YONGYOU_SYNC_STATUS
          searchField.action = AdvancedSearchField.UPDATE_ACTION
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      if (['509', '510'].indexOf(this.configModule) > -1) {
        // 销账抬头
        await this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.$store.getters.currentOfficeId }).then(res => {
          this.receiptInvoiceTitles = res.data
        })
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'actualAmount.ACTUAL_AMOUNT_TITLE'
        searchField.itemLabel = this.$t('CargoMsg.Cargo_WriteOffHeader')
        searchField.tagName = 'invoiceTitle'
        searchField.tagValue = 'invoiceTitle'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dataProvider = this.receiptInvoiceTitles
        searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IS_NULL]
        searchField.filterType = 'global'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$PAYER_NAME'
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 实收实付页面(510) — 开票抬头 + 核销状态 + 销账流水号来源 筛选条件
      if (this.configModule === '510') {
        // 开票抬头
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'input'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_NOT_LIKE]
        searchField.itemName = 'actualAmount.INVOICE_TITLE'
        searchField.itemLabel = this.$t('WriteOff.invoiceTitle')
        searchField.defaultSelected = 1
        searchField.selected = 1
        defaultSearchFields.push(searchField.formatObj2Json())

        // 核销状态（单选框）
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_RADIO'
        searchField.itemCondition = [OPERATOR_EQUAL]
        searchField.itemName = 'actualAmount.WRITEOFF_MATCH_STATUS'
        searchField.itemLabel = this.$t('WriteOff.writeoffMatchStatus')
        searchField.dataProvider = [...ClearingConstants.WRITEOFF_MATCH_STATUSES]
        searchField.tagName = this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 1
        searchField.selected = 1
        defaultSearchFields.push(searchField.formatObj2Json())

        // 销账流水号来源
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_RADIO'
        searchField.itemCondition = [OPERATOR_EQUAL]
        searchField.itemName = 'actualAmount.IMPORT_DATA'
        searchField.itemLabel = this.$t('WriteOff.writeoffSeqNoSource')
        searchField.dataProvider = [
          new CommonState(false, this.$t('WriteOff.sourceSystem'), this.$t('WriteOff.sourceSystem')),
          new CommonState(true, this.$t('WriteOff.sourceImport'), this.$t('WriteOff.sourceImport'))
        ]
        searchField.tagName = this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 1
        searchField.selected = 1
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 青旅
      if (this.qlToFinanceApi) {
        // 同步云平台状态
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_IN.code
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'writeoff._qlPushExternalInterfaceStatus_'
        searchField.itemLabel = 'Clearing.SyncCloudPlatformStatus'
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.QL_KD_SYNC_STATUS
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      } else {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'writeoff._qlPushExternalInterfaceStatus_'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      // if (defaultSearchFields.length > 0) {
      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
      // }
      return this.customSearchItems
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 获取多选选中行
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 查询条件
    getConditions() {
      if (this.conditionsAndRequires) {
        return this.conditionsAndRequires.conditions
      }
      return []
    },
    onView(value) {
      this.pushLogDialog.visible = true
      this.pushLogDialog.uuid = value
    }
  }
}
</script>

<style lang="scss">
.footer-wrapper-writeoff {
  align-items: center;
  .fixedBottom {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
.footer-wrapper-writeoff-dialog {
  align-items: center;
  .fixedBottom {
    position: absolute;
    bottom: 65px;
    right: 45px;
    background: #fff;
  }
}
</style>
